module.exports = __webpack_public_path__ + "static/img/lasting_impressions_about_m.076c909.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lasting_impressions_about_m.jpg
// module id = 705
// module chunks = 1